export class Answer {
    questionId : number;

    questionOptionId : number;

    constructor() {
        this.questionId = 0;
        this.questionOptionId = 0;
    }
}